import React from 'react'
import { BarChartOutlined } from '@ant-design/icons'

const RankingInformationTab = (props) => {
  return (
    <div>
      <h4 className="lead">
        <BarChartOutlined /> Ranking Information
      </h4>
      Ranking Information content
    </div>
  )
}

export default RankingInformationTab
